import React, { Component } from 'react';

import { withStyles } from '@mui/styles';

import APResetImagePlaceholderStyle from "./styles/APResetImagePlaceholder.style";

interface APResetImagePlaceholderState {
  loading: boolean;
}

interface APResetImagePlaceholderProps {
  classes: any;
}

class APResetImagePlaceholder extends Component<
  APResetImagePlaceholderProps,
  APResetImagePlaceholderState
> {
  render() {
    const { classes, ...otherProps } = this.props;

    return <div className={classes.iconSurround} {...otherProps} />;
  }
}

export default withStyles(APResetImagePlaceholderStyle)(
  APResetImagePlaceholder
);
